/* Wall art product page: the product's Size and Format options as the page's pickers see them, plus the page's
 * typographer's quotes (smartQuotes) and the style tiles' order (styleOrder). Pure functions, no DOM. Used by assets/wall-art-pdp.js; tested by _review/wall-art-model.test.cjs.
 * Format values group into Print ("Art Only (no frame)"), Canvas, Metal ("Metal Print") and Framed (every
 * "Framed - …" value; the finish is the rest of the value). Prices are cents, straight from the variants. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.WallArtModel = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var SEP = '\u0000';
  var FRAMED = 'Framed - ';
  var GROUPS = [
    { key: 'print', name: 'Print', test: /^art only/i },
    { key: 'canvas', name: 'Canvas', test: /^canvas/i },
    { key: 'metal', name: 'Metal', test: /^metal/i },
    { key: 'framed', name: 'Framed', test: /^framed\s*-\s*/i }
  ];

  function groupOf(value) {
    for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].test.test(value)) return GROUPS[i].key;
    return null;
  }

  function optionIndex(names, re) {
    for (var i = 0; i < names.length; i++) if (re.test(typeof names[i] === 'string' ? names[i] : names[i].name)) return i;
    return -1;
  }

  function build(product) {
    var si = optionIndex(product.options || [], /size/i), fi = optionIndex(product.options || [], /format/i);
    if (si < 0 || fi < 0) return null;
    var sizes = [], values = [], variants = {};
    (product.variants || []).forEach(function (v) {
      var s = v.options[si], f = v.options[fi];
      if (sizes.indexOf(s) < 0) sizes.push(s);
      if (values.indexOf(f) < 0) values.push(f);
      variants[s + SEP + f] = v;
    });
    var groups = [];
    GROUPS.forEach(function (g) {
      var vals = values.filter(function (f) { return groupOf(f) === g.key; });
      if (vals.length) groups.push({ key: g.key, name: g.name, values: vals });
    });
    var framed = groups.filter(function (g) { return g.key === 'framed'; })[0];
    var finishes = (framed ? framed.values : []).map(function (f) {
      return { value: f, name: f.replace(/^framed\s*-\s*/i, '') };
    });
    return { sizes: sizes, groups: groups, finishes: finishes, variants: variants, si: si, fi: fi };
  }

  function group(model, key) {
    for (var i = 0; i < model.groups.length; i++) if (model.groups[i].key === key) return model.groups[i];
    return null;
  }

  function formatValue(model, sel) {
    if (sel.group === 'framed') return sel.finish;
    var g = group(model, sel.group);
    return g ? g.values[0] : null;
  }

  function variantFor(model, sel) {
    var f = formatValue(model, sel);
    return (f && model.variants[sel.size + SEP + f]) || null;
  }

  function isAvailable(model, sel) {
    var v = variantFor(model, sel);
    return !!(v && v.available);
  }

  function minPrice(list) {
    var avail = list.filter(function (v) { return v && v.available; });
    var pool = avail.length ? avail : list.filter(Boolean);
    if (!pool.length) return null;
    return pool.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity);
  }

  function atSize(model, size, formats) {
    return formats.map(function (f) { return model.variants[size + SEP + f]; }).filter(Boolean);
  }

  function sizeFrom(model, size) {
    var all = [];
    model.groups.forEach(function (g) { all = all.concat(atSize(model, size, g.values)); });
    return minPrice(all);
  }

  function groupPrice(model, size, key) {
    var g = group(model, key);
    if (!g) return null;
    var cents = minPrice(atSize(model, size, g.values));
    return cents == null ? null : { cents: cents, from: key === 'framed' };
  }

  function finishPrice(model, size, value) {
    var v = model.variants[size + SEP + value];
    return v ? v.price : null;
  }

  function selectionOf(model, variant) {
    var s = variant.options[model.si], f = variant.options[model.fi], key = groupOf(f);
    return { size: s, group: key, finish: key === 'framed' ? f : null };
  }

  function defaultSelection(model, variantId) {
    var all = Object.keys(model.variants).map(function (k) { return model.variants[k]; });
    var byId = all.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (byId) return selectionOf(model, byId);
    var first = all.filter(function (v) { return v.available; })[0] || all[0];
    return selectionOf(model, first);
  }

  function parseSize(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
  }

  function cmLabel(text) {
    var s = parseSize(text);
    return s ? Math.round(s.w * 2.54) + ' x ' + Math.round(s.h * 2.54) : '';
  }

  function pct(n) { return n.toFixed(3) + '%'; }

  function vizBox(text, room) {
    var s = parseSize(text);
    if (!s) return null;
    var w = s.w * room.w, h = s.h * room.h;
    return { left: pct(room.cx - w / 2), bottom: pct(room.bottom), width: pct(w), height: pct(h) };
  }

  // The size guide zooms the room so the outline reads at a similar size at every size: scale = 0.40 / (the box's share
  // of the photo's height), between 1 and 2, around the outline's centre (origin in % of the photo, from its top left).
  // The Liquid section renders the same numbers for the first paint.
  var ZOOM_FILL = 0.40, ZOOM_MAX = 2;
  function vizZoom(text, room) {
    var s = parseSize(text);
    if (!s) return null;
    var h = s.h * room.h;                                  // % of the photo's height
    var scale = Math.min(ZOOM_MAX, Math.max(1, (ZOOM_FILL * 100) / h));
    return { scale: Math.round(scale * 10000) / 10000, originX: room.cx, originY: Math.round((100 - room.bottom - h / 2) * 1000) / 1000 };
  }

  // The bounding box of what a glTF model shows in one KHR_materials_variants variant (null: the default materials).
  // A 3d-gen wall-art GLB holds every Format at once and hides the ones not shown with a fully transparent material, so
  // model-viewer's own box (every mesh, hidden or not) is the largest frame's. Its origin is the bottom edge of the
  // piece, so the start camera aimed at that box's centre leaves a smaller format low in the stage.
  // gltf: the GLB's JSON chunk, parsed. Returns { min, max, center } in metres (model space), or null.
  function hiddenMaterial(m) {
    if (!m) return false;
    var mode = m.alphaMode || 'OPAQUE', pbr = m.pbrMetallicRoughness || {};
    var alpha = pbr.baseColorFactor && pbr.baseColorFactor.length === 4 ? pbr.baseColorFactor[3] : 1;
    if (mode === 'MASK') return alpha < (m.alphaCutoff == null ? 0.5 : m.alphaCutoff);
    return mode === 'BLEND' && alpha <= 0;
  }
  function mul(a, b) {                                     // column-major 4x4
    var o = new Array(16);
    for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) {
      o[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    }
    return o;
  }
  function local(n) {
    if (n.matrix && n.matrix.length === 16) return n.matrix.slice();
    var t = n.translation || [0, 0, 0], q = n.rotation || [0, 0, 0, 1], s = n.scale || [1, 1, 1];
    var x = q[0], y = q[1], z = q[2], w = q[3];
    return [
      (1 - 2 * (y * y + z * z)) * s[0], 2 * (x * y + z * w) * s[0], 2 * (x * z - y * w) * s[0], 0,
      2 * (x * y - z * w) * s[1], (1 - 2 * (x * x + z * z)) * s[1], 2 * (y * z + x * w) * s[1], 0,
      2 * (x * z + y * w) * s[2], 2 * (y * z - x * w) * s[2], (1 - 2 * (x * x + y * y)) * s[2], 0,
      t[0], t[1], t[2], 1];
  }
  function variantBounds(gltf, variantName) {
    if (!gltf || !gltf.nodes || !gltf.meshes || !gltf.accessors) return null;
    var names = ((gltf.extensions || {}).KHR_materials_variants || {}).variants || [];
    var vi = -1;
    for (var i = 0; i < names.length; i++) if (names[i].name === variantName) vi = i;
    var mats = gltf.materials || [], min = [Infinity, Infinity, Infinity], max = [-Infinity, -Infinity, -Infinity];
    function primMaterial(p) {
      var maps = ((p.extensions || {}).KHR_materials_variants || {}).mappings || [];
      for (var k = 0; k < maps.length; k++) if (vi !== -1 && maps[k].variants.indexOf(vi) !== -1) return maps[k].material;
      return p.material;
    }
    function walk(index, parent, depth) {
      var n = gltf.nodes[index];
      if (!n || depth > 64) return;
      var m = mul(parent, local(n));
      var mesh = n.mesh != null && gltf.meshes[n.mesh];
      (mesh ? mesh.primitives : []).forEach(function (p) {
        var a = p.attributes && gltf.accessors[p.attributes.POSITION];
        if (!a || !a.min || !a.max || hiddenMaterial(mats[primMaterial(p)])) return;
        for (var c = 0; c < 8; c++) {
          var v = [c & 1 ? a.max[0] : a.min[0], c & 2 ? a.max[1] : a.min[1], c & 4 ? a.max[2] : a.min[2]];
          for (var r = 0; r < 3; r++) {
            var u = m[r] * v[0] + m[4 + r] * v[1] + m[8 + r] * v[2] + m[12 + r];
            if (u < min[r]) min[r] = u;
            if (u > max[r]) max[r] = u;
          }
        }
      });
      (n.children || []).forEach(function (ch) { walk(ch, m, depth + 1); });
    }
    var scene = gltf.scenes && gltf.scenes[gltf.scene || 0];
    var I = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    (scene ? scene.nodes : []).forEach(function (r) { walk(r, I, 0); });
    if (!(min[0] <= max[0])) return null;
    return { min: min, max: max, center: [(min[0] + max[0]) / 2, (min[1] + max[1]) / 2, (min[2] + max[2]) / 2] };
  }

  // Like Liquid's money filter: "$1,234.95". Falls back to plain "$1234.95" where Intl is missing.
  // A style sibling's link (Task 16): sib is { url, variants: [[id, size, format], ...] } from the section's
  // [data-wa-styles-data]. ?variant= names the sibling's variant with this Size and Format (none: no ?variant=). here
  // ({ view, path, hash }, all optional) is the current page: its view parameter is carried through (DEV previews,
  // ?view=wall-art), and with it the /collections/<handle> prefix of a /collections/<handle>/products/... path
  // (Intelligems' redirect rewrites ?view on a plain /products/<handle> URL and drops the template). hash ends the link.
  function styleHref(sib, size, format, here) {
    here = here || {};
    var id = null, list = (sib && sib.variants) || [];
    for (var i = 0; i < list.length; i++) if (list[i][1] === size && list[i][2] === format) { id = list[i][0]; break; }
    var url = String((sib && sib.url) || ''), q = [];
    var coll = here.view && String(here.path || '').match(/^(\/collections\/[^/]+)\/products\//);
    if (coll && /^\/products\//.test(url)) url = coll[1] + url;
    if (id != null) q.push('variant=' + encodeURIComponent(id));
    if (here.view) q.push('view=' + encodeURIComponent(here.view));
    return url + (q.length ? '?' + q.join('&') : '') + (here.hash || '');
  }

  // Typographer's quotes (Task 17) for text the shopper reads: the product description in About the art and the FAQ
  // answers, which wall-art-pdp.js walks text node by text node. The section applies the same rules to its plain-text
  // fields server-side (see the comment there). quoteState() starts a block; curlText(text, state) converts one run of
  // text and carries the state (the previous character, an open double or single quote) into the next run, so a quote
  // split across nodes (`"<em>Thanks</em>, JV"`) still pairs. Characters that are already curly are left alone, and the
  // output has no straight quotes, so a second pass changes nothing.
  //   "  after a digit: ″ (double prime, 6'2"), unless a double quote is open and the number is not feet-and-inches
  //      ("ROAR OF '24", "Class of 2024"): then it closes, ”
  //   "  at the start, or after whitespace, ( [ { — – or an opening quote: “ (opens); any other ": ” (closes)
  //   '  after a digit: ′ (prime, 6'), but ’ before a letter (1990's) or when it closes an open single quote ('24')
  //   '  at the start, or after whitespace, ( [ { — – or an opening quote: ’ before a digit ('26, '24) or an elision
  //      ('em, 'n', 'til, 'tis, 'twas, 'cause, 'bout, 'round), ‘ (opens) before a letter, else ’
  //   '  anywhere else: ’ (apostrophe, or a closing single quote)
  var OPEN_CTX = /[\s(\[{—–“‘]/, DIGIT = /[0-9]/, LETTER = /[A-Za-zÀ-ɏ]/;
  var ELISION = /^(?:em|n|til|tis|twas|cause|bout|round)(?![A-Za-z])/i;
  function quoteState() { return { prev: '', dq: false, sq: false }; }
  function curlText(text, state) {
    state = state || quoteState();
    var s = String(text), out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charAt(i), p = i ? out.charAt(out.length - 1) : state.prev, n = s.charAt(i + 1), atOpen = p === '' || OPEN_CTX.test(p);
      if (c === '"') {
        if (DIGIT.test(p)) {
          var j = out.length - 1;
          while (j >= 0 && /[0-9.]/.test(out.charAt(j))) j--;
          var before = j >= 0 ? out.charAt(j) : '', feet = before === '′' && j > 0 && DIGIT.test(out.charAt(j - 1));
          if (state.dq && !feet) { c = '”'; state.dq = false; } else c = '″';
        } else if (atOpen) { c = '“'; state.dq = true; }
        else { c = '”'; state.dq = false; }
      } else if (c === "'") {
        if (DIGIT.test(p)) {
          if (LETTER.test(n)) c = '’';
          else if (state.sq && !DIGIT.test(n)) { c = '’'; state.sq = false; }
          else c = '′';
        } else if (atOpen) {
          if (DIGIT.test(n) || ELISION.test(s.slice(i + 1))) c = '’';
          else if (LETTER.test(n)) { c = '‘'; state.sq = true; }
          else c = '’';
        } else {
          c = '’';
          if (state.sq && !LETTER.test(n)) state.sq = false;
        }
      }
      out += c;
    }
    if (out) state.prev = out.charAt(out.length - 1);
    return out;
  }
  function smartQuotes(text) { return curlText(text, quoteState()); }
  // The same over an HTML string (for tests and tools; the page walks the DOM): tags, and the text inside code, pre,
  // script, style and textarea, pass through untouched, so attribute values (href="...") keep their quotes. A block
  // tag (p, li, div, br, headings, ...) starts a new quote state.
  var SKIP_TAGS = /^(?:code|pre|script|style|textarea)$/i, BLOCK_TAGS = /^(?:p|div|li|ul|ol|br|h[1-6]|blockquote|section|article|td|th|tr|dd|dt|summary|details|figure|figcaption)$/i;
  function smartQuotesHTML(html) {
    var parts = String(html).split(/(<!--[\s\S]*?-->|<\/?[A-Za-z][^>]*>)/), state = quoteState(), skip = null, out = '';
    for (var i = 0; i < parts.length; i++) {
      var t = parts[i];
      if (i % 2) {
        var m = t.match(/^<(\/?)([A-Za-z][A-Za-z0-9-]*)/);
        if (m) {
          if (skip) { if (m[1] && m[2].toLowerCase() === skip) skip = null; }
          else if (!m[1] && SKIP_TAGS.test(m[2])) skip = m[2].toLowerCase();
          if (BLOCK_TAGS.test(m[2])) state = quoteState();
        }
        out += t;
      } else out += skip ? t : curlText(t, state);
    }
    return out;
  }

  // Style tiles' fixed order (Task 17, the controller's ruling on Task 16): Color, Vintage Paper, Blueprint, Chalkboard,
  // then any other name alphabetically (case-insensitive). The section sorts its siblings by this same key in Liquid;
  // the tests check its render against this.
  var STYLE_ORDER = ['color', 'vintage paper', 'blueprint', 'chalkboard'];
  function styleKey(name) {
    var n = String(name || '').toLowerCase().replace(/^\s+|\s+$/g, ''), k = STYLE_ORDER.indexOf(n);
    return k >= 0 ? String(k) : '9' + n;
  }
  function styleOrder(names) {
    return names.map(function (nm, i) { return { nm: nm, i: i, k: styleKey(nm) }; })
      .sort(function (a, b) { return a.k < b.k ? -1 : a.k > b.k ? 1 : a.i - b.i; })
      .map(function (x) { return x.nm; });
  }

  var usd = null;
  try { usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); } catch (e) { usd = null; }
  function money(cents) { return usd ? usd.format(cents / 100) : '$' + (cents / 100).toFixed(2); }

  return {
    build: build, variantFor: variantFor, isAvailable: isAvailable, sizeFrom: sizeFrom, groupPrice: groupPrice,
    finishPrice: finishPrice, selectionOf: selectionOf, defaultSelection: defaultSelection, parseSize: parseSize,
    cmLabel: cmLabel, vizBox: vizBox, vizZoom: vizZoom, variantBounds: variantBounds, money: money,
    formatValue: formatValue, styleHref: styleHref, quoteState: quoteState, curlText: curlText, smartQuotes: smartQuotes,
    smartQuotesHTML: smartQuotesHTML, styleKey: styleKey, styleOrder: styleOrder
  };
});
